import AxiosClient from './api'
import END_POINT from './constants'
import { TASK_TYPE_NAME, DEFAULT_PAGE } from '../modules/task-management/constants'

export const getTaskCategories = () => {
  const axiosClient = new AxiosClient()
  const uri = END_POINT.TASK_MANAGEMENT.TASK_CATEGORIES
  return axiosClient.get(uri)
    .then((res) => res.data)
}

export const getTaskUserList = ({ id, taskTypeName }) => {
  const axiosClient = new AxiosClient()
  const queryKey = taskTypeName === TASK_TYPE_NAME.DEPARTMENT ? 'departmentId' : 'attributeId'
  const uri = `${END_POINT.TASK_MANAGEMENT.TASK_USER_LIST}?${queryKey}=${id}`
  return axiosClient.get(uri)
    .then((res) => res.data)
}

export const registerNewTask = (payload) => {
  const axiosClient = new AxiosClient()
  const uri = END_POINT.TASK_MANAGEMENT.TASKS
  return axiosClient.post(uri, payload)
    .then((res) => res.data)
}

export const getTasks = (payload) => {
  const { perPage, page } = payload
  const params = {
    perPage: perPage || DEFAULT_PAGE.PER_PAGE,
    page: page || DEFAULT_PAGE.PAGE,
    ...payload
  }
  const axiosClient = new AxiosClient()
  const q = new URLSearchParams(params).toString()
  const uri = `${END_POINT.TASK_MANAGEMENT.TASKS}?${q}`
  return axiosClient.get(uri)
    .then((res) => res.data)
}

export const updateTask = (payload) => {
  const axiosClient = new AxiosClient()
  const uri = `${END_POINT.TASK_MANAGEMENT.TASKS}/${payload.id}`
  return axiosClient.put(uri, payload)
    .then((res) => res.data)
}

export const deleteTask = (taskId) => {
  const axiosClient = new AxiosClient()
  const uri = `${END_POINT.TASK_MANAGEMENT.TASKS}/${taskId}`
  return axiosClient.delete(uri)
    .then((res) => res.data)
}

export const deleteSelectedTasks = (taskIds) => {
  const axiosClient = new AxiosClient()
  const uri = END_POINT.TASK_MANAGEMENT.TASKS
  return axiosClient.delete(uri, taskIds)
    .then((res) => res.data)
}

export const updateTaskOrder = (payload) => {
  const axiosClient = new AxiosClient()
  const uri = END_POINT.TASK_MANAGEMENT.DISPLAY_ORDER
  return axiosClient.put(uri, { taskOrders: payload })
    .then((res) => res.data)
}

export const updateSelectedTasks = (payload) => {
  const axiosClient = new AxiosClient()
  const uri = END_POINT.TASK_MANAGEMENT.BULK_UPDATE
  return axiosClient.patch(uri, payload)
    .then((res) => res.data)
}

export const getUnreadTasks = () => {
  const axiosClient = new AxiosClient()
  const uri = END_POINT.TASK_MANAGEMENT.HAS_UNREAD
  return axiosClient.get(uri)
    .then((res) => res.data)
}

export const updateTaskReadStatus = (payload) => {
  const axiosClient = new AxiosClient()
  const uri = END_POINT.TASK_MANAGEMENT.READ_STATUS
  return axiosClient.post(uri, { taskIds: payload })
    .then((res) => res.data)
}
